import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/constants";
import { useAppDispatch } from "@/hooks/redux";
import { enqueueRequestQueueItem } from "@/store/slices/offline";
import { clearTaskPayload } from "@/store/slices/progress";
import { setTaskCompleted } from "@/store/slices/work";
import { AnyQueueCommand } from "@/types/requestQueue";

interface CompleteTaskParams {
    commands: AnyQueueCommand[];
    metadata?: Record<string, unknown>;
    navigateTo?: string;
}

interface UseCompleteTaskArgs {
    taskId: string;
    targetId: string;
}

export const useCompleteTask = ({ taskId, targetId }: UseCompleteTaskArgs) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return useCallback(
        ({
            commands,
            metadata,
            navigateTo = ROUTES.WorkPlan,
        }: CompleteTaskParams) => {
            dispatch(
                enqueueRequestQueueItem({
                    id: taskId,
                    metadata: {
                        pointId: targetId,
                        taskId,
                        ...metadata,
                    },
                    commands,
                }),
            );

            dispatch(setTaskCompleted({ targetId, taskId }));
            dispatch(clearTaskPayload({ taskId }));
            navigate(navigateTo, { replace: true });
        },
        [dispatch, navigate, taskId, targetId],
    );
};
